import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty, cloneDeep } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { ServicesForcecastSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  ModalWithItem,
  DragDropConfigExportTemplate,
} from '../../../../components/common';
import { tabelColumnExportServicesForcecast, sortServicesForcecast } from '../../constants';
import { getServicesForcecast, getAllServicesForcecast } from '../../actions';
import { makeGetListServicesForcecast, makeGetListAllServicesForcecast } from '../../selectors';
import {
  getPageTotalCount,
  formatMoneyValue,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelServicesForcecast';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfServicesForcecast';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;
let tableColumnsDefault = null;

const listMonth = [
  {
    key: 'JAN',
    value: 1,
    name: 'monthOneRevenue',
  },
  {
    key: 'FEB',
    value: 2,
    name: 'monthTwoRevenue',
  },
  {
    key: 'MAR',
    value: 3,
    name: 'monthThreeRevenue',
  },
  {
    key: 'APR',
    value: 4,
    name: 'monthFourRevenue',
  },
  {
    key: 'MAY',
    value: 5,
    name: 'monthFiveRevenue',
  },
  {
    key: 'JUN',
    value: 6,
    name: 'monthSixRevenue',
  },
  {
    key: 'JUL',
    value: 7,
    name: 'monthSevenRevenue',
  },
  {
    key: 'AUG',
    value: 8,
    name: 'monthEightRevenue',
  },
  {
    key: 'SEP',
    value: 9,
    name: 'monthNineRevenue',
  },
  {
    key: 'OCT',
    value: 10,
    name: 'monthTenRevenue',
  },
  {
    key: 'NOV',
    value: 11,
    name: 'monthElevenRevenue',
  },
  {
    key: 'DEC',
    value: 12,
    name: 'monthTwelveRevenue',
  },
];

class ServicesForcecast extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: { groupByAccount: 'FALSE' },
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listServicesForcecast: [],
    emails: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listServicesForcecast: props.listServicesForcecast,
      totalCount: getPageTotalCount({ ...state, items: props.listServicesForcecast }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetServicesForecastReport },
    } = this.props;
    if (modeGetServicesForecastReport) {
      // Re-check permission
      this.doGetListServicesForcecast();
      this.doGetOutputTemplateByType();
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListServicesForcecast();
    });
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doGetListServicesForcecast());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListServicesForcecast());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListServicesForcecast();
    });
  };

  doGetListServicesForcecast = () => {
    const { filter, page, size, sorted } = this.state;
    const { getServicesForcecast } = this.props;
    const newFilter = cloneDeep(filter);
    if (newFilter.groupByAccount) newFilter.groupByAccount = newFilter.groupByAccount === 'TRUE' ? 'true' : 'false';
    const payload = {
      page: page + 1,
      size,
      filter: newFilter,
      sort:
        !isEmpty(sorted) &&
        sortServicesForcecast[sorted.sortCol] &&
        sortServicesForcecast[sorted.sortCol][sorted.sortDir]
          ? sortServicesForcecast[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    getServicesForcecast(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistServicesForcecast = cb => {
    const { filter, sorted } = this.state;
    const { getAllServicesForcecast } = this.props;
    const newFilter = cloneDeep(filter);
    if (newFilter.groupByAccount) newFilter.groupByAccount = newFilter.groupByAccount === 'TRUE' ? 'true' : 'false';
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter: newFilter,
      sort:
        !isEmpty(sorted) &&
        sortServicesForcecast[sorted.sortCol] &&
        sortServicesForcecast[sorted.sortCol][sorted.sortDir]
          ? sortServicesForcecast[sorted.sortCol][sorted.sortDir]
          : null,
    };
    getAllServicesForcecast(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = newListMonthSorted => {
    this.doGetAlllistServicesForcecast(() => {
      const { isActivePdf, filter } = this.state;
      if (isActivePdf) {
        const { listAllServicesForcecast, t } = this.props;
        convertJson2Pdf({
          data: listAllServicesForcecast,
          t,
          title: t('reportPage:sidebar.servicesForcecast').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.servicesForcecast')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          listMonth: newListMonthSorted,
          filter,
          columnsTable: tableColumnsOutput,
          fontSize: 3,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = (newListMonthSorted, { subject, emailBody }) => {
    this.doGetAlllistServicesForcecast(() => {
      const { listAllServicesForcecast, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf, filter } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'BILLABLE_SERVICES_FORECAST_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.servicesForcecast')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.servicesForcecast')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllServicesForcecast,
            t,
            columns: tableColumnsOutput,
            listOptionFields: { cutOffDom: 'cutOffDOM' },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllServicesForcecast,
          t,
          title: t('reportPage:sidebar.servicesForcecast').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.servicesForcecast')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          listMonth: newListMonthSorted,
          filter,
          isFile: true,
          columnsTable: tableColumnsOutput,
          fontSize: 3,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.servicesForcecast')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('SERVICE_FORECAST_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tableColumnsDefault,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      filter,
      listServicesForcecast,
      emails,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllServicesForcecast,
      t,
      permissions: { modeGetServicesForecastReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetServicesForecastReport) return '';
    const indexStartMonth =
      listServicesForcecast && listServicesForcecast.length
        ? listMonth.findIndex(val => val.key.toLowerCase() === listServicesForcecast[0].startMonth.toLowerCase())
        : 0;
    const defaultMonth = cloneDeep(listMonth);

    // console.log('listServicesForcecast', listServicesForcecast);
    // const newListMonth = [
    //   ...defaultMonth.splice(moment().month(), defaultMonth.length - 1),
    //   ...defaultMonth.splice(0, moment().month() - 1),
    // ];

    const newListMonth = [
      ...defaultMonth.splice(indexStartMonth, defaultMonth.length),
      ...defaultMonth.splice(0, indexStartMonth),
    ];

    const newListMonthSorted = newListMonth.map(month => {
      const slt = t
        ? t('selections:monthOfYear')().find(val => val.value.toLowerCase() === month.key.toLowerCase())
        : '';
      return {
        name: month.name,
        label: slt.label,
        key: month.key,
        render: (colName, item) => {
          const dataRevenue = item && item[month.name] !== undefined ? item[month.name] : 0;
          return <span>{formatMoneyValue(dataRevenue)}</span>;
        },
      };
    });

    const newTableColunms = [...tabelColumnExportServicesForcecast(filter), ...newListMonthSorted];
    tableColumnsDefault = newTableColunms;
    const exportColumns = exportColumnsSave || {};

    tableColumnsOutput = exportColumns?.targetFields?.items || [];

    const inAdvanceFlag = {
      name: 'inAdvanceFlag',
      label: 'label.inAdvanceFlag',
      render: (colName, item) => {
        if (filter && filter.groupByAccount === 'TRUE') return '';
        return <span>{item.inAdvanceFlag ? 'TRUE' : 'FALSE'}</span>;
      },
    };
    if (tableColumnsOutput && tableColumnsOutput.length) {
      tableColumnsOutput = tableColumnsOutput.map(val => {
        const { ...rest } = val;
        if (val && val.name === 'inAdvanceFlag') {
          rest.render = inAdvanceFlag.render;
        }
        return { ...rest };
      });
    }

    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.servicesForcecast') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.servicesForcecast')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <ServicesForcecastSearchForm
                  onSubmit={this.onHandleSubmitSearch}
                  defaultFilter={{ groupByAccount: 'FALSE' }}
                />
              </div>
              <div>
                <div className="mt-3 mb-4 pt-3 row">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}

                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={() => this.onExport(newListMonthSorted)} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.servicesForcecast').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllServicesForcecast,
                          t,
                          listMonth: newListMonthSorted,
                          filter,
                          title: t('reportPage:sidebar.servicesForcecast').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.servicesForcecast')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={e => this.sendEmail(newListMonthSorted, e)}
                      data={listServicesForcecast}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={listServicesForcecast && listServicesForcecast.length ? listServicesForcecast : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

ServicesForcecast.propTypes = {
  getServicesForcecast: PropTypes.func,
  getAllServicesForcecast: PropTypes.func,
  listAllServicesForcecast: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.objectOf(PropTypes.any)]),
};

ServicesForcecast.defaultProps = {
  getServicesForcecast: () => {},
  getAllServicesForcecast: () => {},
  listAllServicesForcecast: [],
};

const mapStateToProps = createStructuredSelector({
  listServicesForcecast: makeGetListServicesForcecast() || [],
  listAllServicesForcecast: makeGetListAllServicesForcecast() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getServicesForcecast,
    getAllServicesForcecast,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
  })(ServicesForcecast)
);
